import React from 'react';
import { StarIcon } from 'lucide-react';
export function TestimonialsSection() {
  const testimonials = [{
    name: 'Sandra M.',
    location: 'Austin TX',
    text: 'I was completely lost after my mother passed. This guide walked me through everything — the probate process, the tax stuff, even how to talk to my siblings about the house. Worth every penny.'
  }, {
    name: 'Robert T.',
    location: 'Cleveland OH',
    text: "I'm 67 and not tech-savvy, but this was written in plain English. I followed the checklist and avoided what could've been a $12,000 mistake with the title transfer."
  }, {
    name: 'Patricia L.',
    location: 'Savannah GA',
    text: 'I bought this for my sister and me after Dad passed. It gave us a clear plan and stopped the arguments. We both felt more confident within a week.'
  }, {
    name: 'Michael R.',
    location: '63 — Retired, Orlando FL',
    text: "I didn't even know my father's house had a reverse mortgage until the bank sent a letter. I used the Letter of Intent template in this kit and bought myself 6 months. That gave me enough time to sell the house without losing it to foreclosure. Worth every penny and then some."
  }];
  return <section className="bg-warm-white py-20 px-6 border-t border-slate-light/20" data-id="element-399">
      <div className="max-w-7xl mx-auto" data-id="element-400">
        <h2 className="text-3xl md:text-4xl font-bold text-navy text-center mb-16" data-id="element-401">
          What Readers Are Saying
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-402">
          {testimonials.map((testimonial, index) => <div key={index} className="bg-white rounded-lg p-8 shadow-sm border border-slate-light/20 flex flex-col" data-id="element-403">
              <div className="flex gap-1 mb-6" data-id="element-404">
                {[...Array(5)].map((_, i) => <StarIcon key={i} className="w-5 h-5 fill-gold text-gold" data-id="element-405" />)}
              </div>

              <p className="text-text-dark font-body text-lg leading-relaxed mb-8 flex-grow italic" data-id="element-406">
                "{testimonial.text}"
              </p>

              <div data-id="element-407">
                <p className="font-bold text-navy font-body" data-id="element-408">
                  {testimonial.name}
                </p>
                <p className="text-text-muted font-body text-sm" data-id="element-409">
                  {testimonial.location}
                </p>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}